import React from 'react';
import { formatCompletionDate } from '../../components/helpers';

function PipCard({ project }) {
  return (
    <div className="grid__col-xs-12 grid__col-xl-6">
      <div
        className={`card-project card-project--${project.status.toLowerCase()}`}
      >
        <div className="card-project__address">
          <div className="card-project__street">{project.address}</div>
          <span>
            {project.city}, {project.state} {project.zipcode}
          </span>
        </div>
        <div className="card-project__status">
          <span className="card-project__status-indicator">
            {project.status}
          </span>
          {project.new_messages > 0 && (
            <div className="card-project__messages">
              {project.new_messages} Unread{' '}
            </div>
          )}
        </div>
        <div className="card-project__completion-date">
          <div>
            Complete Date:{' '}
            <span>{formatCompletionDate(project.completion_date)}</span>
          </div>
        </div>
        <div className="card-project_qualify-for">
          <div>
            Qualifying for{' '}
            <span className="card-project_qualify-amount">
              {parseInt(project.appliance_total_incentives) > 0
                ? `$${parseInt(
                    project.appliance_total_incentives
                  ).toLocaleString()}`
                : 'TBD'}
            </span>
          </div>
        </div>
        <div className="card-project__view-details">
          <a
            href={project.permalink}
            className="btn btn--link btn--sm btn--has-arrow module-hover-root"
          >
            <span className="btn__content">
              <span className="btn__text">View/Edit Details</span>
              <span className="btn__arrow arrow"></span>
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default PipCard;
